import React, {createContext, useContext, useState} from 'react';
import {toast} from 'react-hot-toast';
import useLocalStorage from '../hooks/useLocalStorage';
import lang from "../JSON-FILES/lang.json"

const Context = createContext();

export const OfflineContext = ({children}) => {
    // Include error states from useLocalStorage
    const [offlineData, setOfflineData, offlineError] = useLocalStorage("offlineData", []);
    const [base64Images, setBase64Images, imagesError] = useLocalStorage("base64Images", []);
    
    // Track pending operations
    const [isPending, setIsPending] = useState(false);

    // Wrapper function to handle offline data updates safely
    const updateOfflineData = async (newData) => {
        if (isPending) {
            toast.error('Another update is in progress. Please wait.');
            return false;
        }

        try {
            setIsPending(true);

            // Ensure data is always an array
            const dataToStore = Array.isArray(newData) ? newData : [];
            
            // Store the data
            setOfflineData(dataToStore);

            toast.success('Changes saved offline');
            return true;
        } catch (err) {
            console.error('Error updating offline data:', err);
            toast.error(`Failed to save changes: ${err.message}`);
            return false;
        } finally {
            setIsPending(false);
        }
    };

    return (
        <Context.Provider
            value={{
                offlineData, 
                setOfflineData: updateOfflineData,
                base64Images, 
                setBase64Images,
                offlineError,
                imagesError,
                isPending
            }}>
            {children}
        </Context.Provider>
    )
}

export const useOfflineContext = () => useContext(Context);
